import { render, staticRenderFns } from "./HomeScroll2.vue?vue&type=template&id=34705837&scoped=true&"
import script from "./HomeScroll2.vue?vue&type=script&lang=js&"
export * from "./HomeScroll2.vue?vue&type=script&lang=js&"
import style0 from "./HomeScroll2.vue?vue&type=style&index=0&id=34705837&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34705837",
  null
  
)

export default component.exports